import PublicActivityType from '@/pages/publicPages/PublicActivityType/PublicActivityType';
import PublicActivityTypeSSP from '@/pages/publicPages/PublicActivityType/PublicActivityType.ssp';
import PageMetadata from '@/v2/domains/SEO/components/PageMetadata/PageMetadata';

export default function PictureDictionaries(props) {
  return (
    <>
      <PageMetadata title="Picture Dictionary for Kids – Fun & Educational Spanish Vocabulary | Rockalingua" />
      <PublicActivityType {...props.pageProps} />
    </>
  );
}

export const getServerSideProps = async (context) =>
  await PublicActivityTypeSSP({ context, activityType: 'pictureDictionary' });
